
import { useNavigate } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Button from '../../../components/base/Button';
import JsonViewer from '../../../components/base/JsonViewer';

export default function InvoiceTemplate() {
  const navigate = useNavigate();

  const invoiceSchema = {
    "invoice_number": "",
    "invoice_date": "",
    "due_date": "",
    "vendor_name": "",
    "vendor_address": "",
    "vendor_tax_id": "",
    "customer_name": "",
    "customer_address": "",
    "customer_tax_id": "",
    "billing_address": "",
    "shipping_address": "",
    "subtotal": "",
    "tax_amount": "",
    "tax_rate": "",
    "discount_amount": "",
    "discount_percentage": "",
    "total_amount": "",
    "currency": "",
    "payment_terms": "",
    "payment_method": "",
    "line_items": "",
    "item_description": "",
    "quantity": "",
    "unit_price": "",
    "line_total": "",
    "notes": ""
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-cyan-50">
      <Navbar showUserActions={true} />
      
      <div className="px-4 py-6">
        <Button variant="outline" onClick={() => navigate('/templates')} className="mb-6">
          <i className="ri-arrow-left-line mr-2"></i>
          Back to Templates
        </Button>
      </div>
      
      <div className="flex flex-col items-center px-4">
        <div className="w-full max-w-4xl">
          <div className="text-center mb-8">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-indigo-100">
              <i className="ri-file-text-line text-2xl text-indigo-600"></i>
            </div>
            <h1 className="text-3xl font-bold text-gray-800 mb-2">Invoice Template</h1>
            <p className="text-lg text-gray-600">JSON Schema - View Only</p>
            <div className="w-full h-px bg-gray-300 mt-4"></div>
          </div>
          
          <div className="bg-white rounded-lg shadow-lg p-6">
            <div className="mb-4">
              <h2 className="text-xl font-semibold text-gray-800 mb-2">Schema Structure</h2>
              <p className="text-gray-600 text-sm mb-4">
                This template parses invoices and billing documents for financial data extraction.
              </p>
            </div>
            
            <JsonViewer data={invoiceSchema} />
          </div>
        </div>
      </div>
    </div>
  );
}
